import jsPDF from "jspdf";
import "jspdf-autotable";

const exportPDF = (records, formatOutcome) => {
  const unit = new jsPDF();

  unit.autoTable({
    head: [
      [
        "Observer",
        "Facility",
        "Unit",
        "HCW Type",
        "Moment",
        "Outcome",
        "Rings",
        "Gloves",
        "Nails",
        "Bracelet",
        "Created Date",
        "Comments",
      ],
    ],
    body: records.map((record) => [
      record.nurse,
      record.facility,
      record.unit,
      record.formQuestions.healthCareWorker,
      record.formQuestions.handHygieneMoment,
      formatOutcome(record.formQuestions.outcome, record.formQuestions.timer),
      record.formQuestions.custom.rings ? "Yes" : "No",
      record.formQuestions.custom.gloves ? "Yes" : "No",
      record.formQuestions.custom.nails ? "Yes" : "No",
      record.formQuestions.custom.bracelet ? "Yes" : "No",
      new Date(record.createdAt).toLocaleString(),
      record.formQuestions.comment,
    ]),
    tableWidth: "auto",
    styles: {
      lineColor: [0, 0, 0], // Color of the lines
      lineWidth: 0.5, // Width of the lines
    },
  });

  unit.save("hand_hygiene_records.pdf");
};

export default exportPDF;
